const ErrorHandler = () => null

export default ErrorHandler
